let now: () => number;
if (process.browser) {
  now = () => performance.now();
} else {
  (async () => {
    const {performance} = await import('perf_hooks');
    now = () => performance.now();
  })();
}

/**
 * Starts a timer and returns a stop function. The stop function returns the time in milliseconds that are between the requests
 */
export const startSpan = () => {
  const start = now();
  return () => {
    const end = now();
    const diffInMilliseconds = end - start;

    return Number(diffInMilliseconds);
  };
};
